import React from 'react'

import TermsAndConditions from '@/components/terms_and_conditions'
import { MainLayout } from '@/root/src/layouts'
import gssp from '@/utils/gssp'

const TermAndConditionPage = () => {
  return (
    <MainLayout>
      <TermsAndConditions />
    </MainLayout>
  )
}

export default TermAndConditionPage

export const getServerSideProps = gssp()
